import { render, staticRenderFns } from "./approvalWarning.vue?vue&type=template&id=0ce9dc42&scoped=true"
import script from "./approvalWarning.vue?vue&type=script&lang=js"
export * from "./approvalWarning.vue?vue&type=script&lang=js"
import style0 from "./approvalWarning.vue?vue&type=style&index=0&id=0ce9dc42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce9dc42",
  null
  
)

export default component.exports